import Enum from "../../../../class/Enum"

export default Enum.make(["DOCUMENT_UNREADABLE", "DOCUMENT_NOT_ACCEPTED", "DOCUMENT_HAS_EXPIRED", "DOCUMENT_INCOMPLETE", "DOCUMENT_MISSING", "DOCUMENT_DO_NOT_MATCH_USER_DATA", "DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA", "SPECIFIC_CASE", "DOCUMENT_FALSIFIED", "UNDERAGE_PERSON", "SPECIFIC_CASE"]);
